<template>
	<div class="topDiv d-flex align-items-center">
		<div>
			<b-form-checkbox
				switch
				:disabled="disabled"
				class="mt-2 custom-input-switch"
				size="lg"
				:id="id"
				:type="type"
				:placeholder="placeholder"
				v-model="inputData"
				@input="type == $emit('select-value', inputData)"
			></b-form-checkbox>
		</div>
		<div class="mt-3">
			<label class="teams-label-font mb-1">{{ label }}</label>
		</div>
	</div>
</template>

<script>
export default {
	name: "Switch",
	props: {
		disabled: Boolean,
		type: String,
		label: String,
		mandatory: Boolean,
		placeholder: String,
		id: String,
		vmodel: {
			validator: function () {
				// Accept any type
				return true;
			},
		},
	},
	data() {
		return {
			inputData: false,
		};
	},
	created() {
		if (this.vmodel) {
			this.inputData = this.vmodel;
		}
	},
};
</script>
